import type { ComponentLoaderType } from '@grafikr/components';

const Loader: ComponentLoaderType = ({ node, emitter }, load) => {
  const events = node.dataset.loadEvent.split(' ');

  const loadWrapper = () => {
    if (document.body.contains(node)) {
      load();
    }
  };

  events.forEach((event) => {
    emitter.on(event, loadWrapper);
  });

  return () => {
    events.forEach((event) => {
      emitter.off(event, loadWrapper);
    });
  };
};

export default Loader;
